$(document).ready(function() {
   $('.loop-1-main .hover-element').hover(
            function() {
                // On mouse enter
                var newSrc = $(this).data('img');
                $('.loop-1-main #display-image').attr('src', newSrc);
                $('.loop-1-main #display-image').addClass('active');
            },  
            function() {
                // On mouse leave
                $('.loop-1-main #display-image').removeClass('active');
                $('.loop-1-main #display-image').fadeOut(500);
            }
        );
  
   $('.loop-2-main .hover-element').hover(
            function() {
                // On mouse enter
                var newSrc = $(this).data('img');
                $('.loop-2-main #display-image').attr('src', newSrc);
                $('.loop-2-main #display-image').addClass('active');
            }, 
            function() {
                // On mouse leave
                $('.loop-2-main #display-image').removeClass('active');
                $('.loop-2-main #display-image').fadeOut(500);
            }
        );  
  
   $('.loop-3-main .hover-element').hover(
            function() {
                // On mouse enter
                var newSrc = $(this).data('img');               
                $('.loop-3-main #display-image').attr('src', newSrc);              
                $('.loop-3-main #display-image').addClass('active');
            }, 
            function() {
                // On mouse leave
                $('.loop-3-main #display-image').removeClass('active');              
                $('.loop-3-main #display-image').fadeOut(500);                
            }
        );  
  
    $('.loop-4-main .hover-element').hover(
            function() {
                // On mouse enter
                var newSrc = $(this).data('img');
                $('.loop-4-main #display-image').attr('src', newSrc);
                $('.loop-4-main #display-image').addClass('active');               
            }, 
            function() {
                // On mouse leave
                $('.loop-4-main #display-image').removeClass('active');
                $('.loop-4-main #display-image').fadeOut(500);
            }
        );
    });

$(document).ready(function() {
   $('.collectio-filters').hover(
            function() {
                // On mouse enter                
                $('.collectio-filters form#FacetFiltersFormMobile').css('z-index','0');
               
            }, 
            function() {
                // On mouse leave
              setTimeout(function () { 
                $('.collectio-filters form#FacetFiltersFormMobile').css('z-index','-1');
              }, 500);  
            }
        );
});


$(document).ready(function() {            
$('#show_account').on('click', function(event) {
     $('#show_drop').toggle();    
     event.stopPropagation(); // Prevent click event from bubbling up to document
});

$(document).on('click', function() {
     $('#show_drop').hide();     
});
});

$(document).ready(function() {
  $('.media_slider').slick({  
  slidesToShow: 1,
  arrows: true,
  draggable: true,  
  dots: true,   
  autoplay: false,
  infinite: true,
  autoplaySpeed: 4000,
  pauseOnHover: false,
  pauseOnFocus: false  
});

});



$(document).ready(function(){  
  
$("li.levelone-menu").hover(function () {
    $(".header__inline-menu").addClass("inline-menu-open");
  },
  function () {
    $(".header__inline-menu").removeClass("inline-menu-open");
    $(".header__submenu").removeClass("header__submenu-open");
    $('.header__submenu details').removeAttr("open");
    $("#display-image").removeClass("active");    
});

$("li.levelone-menu-nochild").hover(function () {
    $(".header__inline-menu").addClass("levelone-menu-nochild");
  },
  function () {
    $(".header__inline-menu").removeClass("levelone-menu-nochild");
    $(".header__submenu").removeClass("header__submenu-open");
    $('.header__submenu details').removeAttr("open");
    $("#display-image").removeClass("active");    
});

  

//$("summary.levelone-menu").click(function(){
    //$(".header__inline-menu").toggleClass("inline-menu-open");
    //$(".header__submenu").removeClass("header__submenu-open");
    //$('.header__submenu details').removeAttr("open");

//setTimeout(function () {    
//if($('header-menu>details[open]').length) {
      // $(".header__inline-menu").addClass("inline-menu-open");
    //} else {
      // $(".header__inline-menu").removeClass("inline-menu-open");       
   // }
//}, 100); 
//});
  

$(".header__submenu summary.header__menu-item").click(function(){
setTimeout(function () {    
if($('.header__submenu details[open]').length) {
        //alert('true');
    } else {
        $(".header__submenu").removeClass("header__submenu-open");    
    }
}, 100);   
    
    $(".header__submenu").addClass("header__submenu-open");    
}); 


//// Mobile Menu

$(".menu-drawer__inner-submenu summary.menu-drawer__menu-item").click(function(){
setTimeout(function () {    
if($('.menu-drawer__inner-submenu details[open]').length) {
        //alert('true');
    } else {
        $(".menu-drawer__inner-submenu").removeClass("mobile_submenu-open");    
    }
}, 100); 
    $(".menu-drawer__inner-submenu").addClass("mobile_submenu-open");    
});
  
$(".menu-drawer__inner-submenu .menu-drawer__close-button").click(function(){
     $(".menu-drawer__inner-submenu").removeClass("mobile_submenu-open");  
}); 
$(".header__icon--menu").click(function(){
     $(".menu-drawer__inner-submenu").removeClass("mobile_submenu-open");  
});   

///// end menu  

  

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.list-menu--inline').length)  {
        $(".header__inline-menu").removeClass("inline-menu-open");
        $(".header__submenu").removeClass("header__submenu-open");
        $('.header__submenu details').removeAttr("open");
    }
  });
  
});


window.addEventListener('DOMContentLoaded',(event)=>{
document.querySelectorAll('facet-filters-form details.mobile-facets__details').forEach(item=>{
if(!item.hasAttribute('open')){
item.querySelector('summary').click()
}
})
});


document.addEventListener("DOMContentLoaded", function() {
if ($(window).width() > 749) {  
$('.product-media-slider').slick({ 
   centerMode: true,
  centerPadding: '50px', 
  slidesToShow: 3,
  //accessibility: false,
  variableWidth: true,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0,
  infinite: true,  
  speed: 500,
  pauseOnHover: false,
  arrows: true,
  dots: false, 
  slickGoTo: 1,
  responsive: [
      {
        breakpoint: 1439,
        settings: {
          variableWidth: false,
        }
      },  
      {
        breakpoint: 989,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
        }
      }      
    ]
});

$('.product-media-slider').slick('slickGoTo', 1); 
  
}  
});

document.addEventListener("DOMContentLoaded", function() {
if ($(window).width() < 750) {  
$('.product__media-wrapper .product__media-list').slick({ 
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,  
  infinite: false,  
  speed: 500,
  pauseOnHover: false,
  arrows: false,
  dots: true
});
}  
});



 $(document).ready(function() {
   $('.section-main-product .tabs li:first-of-type').addClass('active');
   $('.section-main-product .product-tab-section .tab-content:first-of-type').addClass('active');
   
        $('.tabs li').click(function() {
            var tab_id = $(this).data('tab');

            $('.tabs li').removeClass('active');
            $('.tab-content').removeClass('active');

            $(this).addClass('active');
            $("#" + tab_id).addClass('active');
        });
    });


$(document).ready(function() {
setTimeout(function () {
var s1w = $('.variant-picker-boy-now .product-form__input--pill .s1w input[type=radio]:checked+label').text();
  
$('.addc-s1w').append(s1w);
var sizes = $('.addc-s1w').text();
if(sizes == " "){
  $('.product-form__buttons').addClass('disabled'); 
  $(".product-form__submit").attr("disabled", true); 
  $('.empty_screen').text("Add To Bag");
  $('span.label-down').text("Select A Size");
} else{
   $('.product-form__buttons').removeClass('disabled'); 
   $('span.label-down').text("Add To Bag");
   $(".product-form__submit").attr("disabled", false); 
}
var s2w = $('.variant-picker-boy-now .product-form__input--pill .s2w input[type=radio]:checked+label').text();
$('.addc-s2w').append(s2w);   
//var sizes_2 = $('.addc-s2w').text();
//if(sizes_2 == " "){
 // $('.empty_screen').text("Add To Bag");
  //$('.product-form__buttons').addClass('disabled');
//} else{
//$('.product-form__buttons').removeClass('disabled'); 
//}
  

  
var addcprice = $('.product__info-container .price .price-item--regular').text();
$('.addc-price').append(addcprice);   
  

$('.variant-picker-boy-now .product-form__input--pill .s1w label').click(function(){
    var s1w = $(this).text();
    //alert(s1w);
    $('.product-form__buttons').removeClass('disabled'); 
    $(".product-form__submit").attr("disabled", false); 
    $('.empty_screen').text("Add");
    $('span.label-down').text("Add To Bag");
    $('.addc-s1w').html(s1w);
});

$('.variant-picker-boy-now .product-form__input--pill .s2w label').click(function(){
    var s2w = $(this).text();
    //$('.product-form__buttons').removeClass('disabled'); 
    //$('.empty_screen').text("Add");
    $('.addc-s2w').html(s2w);  
});   
}, 300); 

$('.variant-picker-boy-now .product-form__input--pill label').click(function(){ 
  setTimeout(function () {
  var addcprice1 = $('.product__info-container .price .price-item--regular').text();
  $('.addc-price').html(addcprice1); 
    
}, 1000);  
});  

});

$(document).ready(function(){
  setTimeout(function () {
    $('.product-form__buttons.product-form_buttons_gifting').removeClass('disabled'); 
    $(".product-form_buttons_gifting .product-form__submit").attr("disabled", false);
  }, 500);   
});

$(document).ready(function(){
  $(".size-guide-button").click(function(){
    $('.size-guide-popup-main').css('display', 'flex');
    $('body').addClass('overflow-hidden');    
  });

  $(".sizing-assistance strong").click(function(){
    $('.size-guide-popup-main').css('display', 'flex');
    $('body').addClass('overflow-hidden');    
  });
 
  $(".size-guide-button-close").click(function(){
    $('.size-guide-popup-main').css('display', 'none');
    $('body').removeClass('overflow-hidden');
  });  
});


$(document).ready(function () {    
    $(".contant_faq_title").click(function () {
        if ($('.contant_faq_text').is(':visible')) {
            $(".contant_faq_text").slideUp(300);            
        }
        if ($(this).next(".contant_faq_text").is(':visible')) {
            $(this).next(".contant_faq_text").slideUp(300);            
        } else {
            $(this).next(".contant_faq_text").slideDown(300);           
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
var $slider = $('.journal-template-slider');
       var autoplayOnce = true;
  
        var $currentSlide = $('.current-slide');
        var $totalSlides = $('.total-slides');
        $slider.on('init', function(event, slick){
            $totalSlides.text(slick.slideCount);
        });
        $slider.on('afterChange', function(event, slick, currentSlide){
            $currentSlide.text(currentSlide + 1);               

          if (currentSlide === slick.slideCount - 1) {
                $('.next-artical').insertBefore('.slider-counter');                
                autoplayOnce = false; // Ensure this runs only once
          }else{
            $('.next-artical').insertAfter('.jts-six-inner');
            }
          
        });
$slider.slick({ 
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,  
  infinite: false,  
  speed: 500,
  fade: true,
  //autoplaySpeed: 3000,
  pauseOnHover: false,
  pauseOnFocus: false,
  arrows: true,  
  dots: false,  
    responsive: [
      {
        breakpoint: 989,
        settings: {
          speed: 500,
        }
      }      
    ]
});
});


$(document).ready(function(){  
if ($(window).width() < 990) {
    $(".section-with-latest-collection #product-grid li.grid__item.prd-right-col").insertBefore(".section-with-latest-collection #product-grid li.grid__item.prd-17-col");
    $(".section-with-campaign-imagery #product-grid li.grid__item.prd-right-col").insertBefore(".section-with-campaign-imagery #product-grid li.grid__item.prd-17-col");
}
});


$(document).ready(function() {            
$('.custitle').on('click', function(event) {
     $('.menuaccount-inner').toggle();
     $('.menu-drawer__utility-links').toggleClass('active-account');  
     $('.menu-drawer__utility-links').removeClass('active-curency');
     event.stopPropagation(); // Prevent click event from bubbling up to document
});

$(document).on('click', function() {
     $('.menuaccount-inner').hide();
     $('.menu-drawer__utility-links').removeClass('active-account');
});

            
$('.mobilemenu-currency form button.disclosure__button').on('click', function(event) {    
     $('.menu-drawer__utility-links').toggleClass('active-curency');  
     $('.menu-drawer__utility-links').removeClass('active-account');   
     $('.menuaccount-inner').hide();
     event.stopPropagation(); // Prevent click event from bubbling up to document     
});
$(document).on('click', function() {    
     $('.menu-drawer__utility-links').removeClass('active-curency');
});



 $('.mobile-bag').on('click', function(event) {
     $('cart-drawer.drawer').addClass('active');     
  });  
  
    
});      



document.addEventListener("DOMContentLoaded", function() {  
var sldLength = $('.swatch-box.s1w .swatch-nner').length;
if (sldLength > 6 ) { 
$('.swatch-box.s1w').slick({ 
  slidesToShow: 6,
  slidesToScroll: 5,
  autoplay: false,  
  infinite: false,  
  speed: 500,
  pauseOnHover: false,
  arrows: true,
  dots: false,
  responsive: [      
      {
        breakpoint: 750,
        settings: {
          slidesToScroll: 8,
          infinite: false,
          arrows: false,
          speed: 200,
          draggable: true,
          swipe: true,
          variableWidth: true,
          verticalSwiping: false,
          cssEase: 'linear',
        }
      }
    ]
}); 
} 
});


document.addEventListener("DOMContentLoaded", function() {
$(".announcement-close").on('click', function() {    
     $('.announcement-bar-section').remove();
});
});           


$(document).ready(function(){  
if ($(window).width() <750) {
    $(".collectio-filters summary.mobile-facets__open-wrapper").click(function(){
        $(".collectio-filters form#FacetFiltersFormMobile").toggle();
         $("body").toggleClass("bgshow enfilter");
    });

     $(".sortbycustom .facet-filters__label").click(function(){
        $(".sortbycustom-inner").toggle();
         $("body").toggleClass("bgshow ensort");
    });
}
});

$(document).ready(function(){ 
$( ".menu-item-find").click(function() {
setTimeout(function () {  
  $(".mobile-menu-search input.search__input").focus();  
}, 1000);   
});  
});  



document.addEventListener("DOMContentLoaded", function() {
if ($(window).width() > 749) {  
$('body.template-product .product-media-modal__dialog .product-media-modal__content').slick({   
  slidesToShow: 2, 
  variableWidth: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  infinite: true,  
  speed: 500,
  pauseOnHover: false,
  arrows: true,
  dots: false
});
}  
});


document.addEventListener("DOMContentLoaded", function() {  
var tablength = $('.product-tab-main .tabs li').length;
if (tablength < 5 ) { 
$('.product-tab-main .tabs').addClass("showcenters");
} 

var swatchboxtwo = $('.swatch-box.s2w .swatch-nner').length;
if (swatchboxtwo < 3 ) { 
$('.swatch-box.s2w').addClass("showcenters");
}  
});


document.addEventListener("DOMContentLoaded", function() { 
if ($(window).width() < 750) {   
var giftngth = $('.section-gifting-product-main .swatch-box.s1w .swatch-nner').length;
if (giftngth > 5 ) { 
$('.section-gifting-product-main .swatch-box.s1w').slick({ 
  slidesToShow: 5,
  slidesToScroll: 3,
  autoplay: false,  
  infinite: false,  
  speed: 200,
  pauseOnHover: false,
  arrows: true,
  dots: false,
  draggable: true,
  swipe: true,
  variableWidth: true,
  verticalSwiping: false,
  cssEase: 'linear',
}); 
} 
}  
});       


document.addEventListener("DOMContentLoaded", function() { 
if ($(window).width() > 1439) { 
$('.section-gifting-product-main .tabs li').on('click', function(e) { 
var aaaaaa = $(window).scrollTop();  
  if (aaaaaa < 200) {
     $("html, body").animate({ scrollTop: "200" });
  }
});
}
});  


$(document).ready(function(){ 
 setTimeout(function () { 
   $('.materials-m-select input').each(function() {
    var dddd = $(this).val();
    if(dddd == 'M'){
     $(this).click();
      $('.addc-s1w').append(dddd);        
     $(".product-form__buttons").removeClass("disabled"); 
      
      var sldLength = $('.swatch-box.s1w .swatch-nner').length;
      if (sldLength > 6 ) {
       var dataId = $(this).parent().data('slickIndex');  
     $('.materials-m-select').slick('slickGoTo', dataId); 
      }
    }
  });      
 }, 1000);  
});  


document.addEventListener("DOMContentLoaded", function() {  
if ($(window).width() > 989) {
    $("body.template-sapphire-collection").addClass("sapphire-white-header");
  
var sapphireLength = $('.template-sapphire-collection').length;
if (sapphireLength) {
const element = document.querySelector('.template-sapphire-collection .rowcound1s'); 
const elementbody = document.querySelector('.template-sapphire-collection');   
const className = 'sapphire-white-header'; 
function toggleClassOnScroll() {
    if (window.scrollY > element.offsetTop) {
        elementbody.classList.remove(className);      
    } else {
        elementbody.classList.add(className);
    }
}
window.addEventListener('scroll', toggleClassOnScroll);
}
  
}
});